import * as _ from 'lodash';
//  Note that we are intentionally using this Project type (and not the model-typings one), since it includes the associations that we need.
import type { Project, SelectOption } from '../../../../types';
import type { Category } from '../../../../../shared/issuesV2';

const projectLicensingIssueSettingsFields = [
  'policyId',
  'licensingIssueScanningEnabled',
  'licensingStatusCheckEnabled',
] as const;
export type ProjectLicensingIssueSettings = Pick<Project, typeof projectLicensingIssueSettingsFields[number]>;

const projectSecurityIssueSettingsFields = [
  'securityPolicyId',
  'securityIssueScanningEnabled',
  'securityStatusCheckEnabled',
] as const;
export type ProjectSecurityIssueSettings = Pick<Project, typeof projectSecurityIssueSettingsFields[number]>;

const projectQualityIssueSettingsFields = [
  'qualityPolicyId',
  'qualityIssueScanningEnabled',
  'qualityStatusCheckEnabled',
] as const;
export type ProjectQualityIssueSettings = Pick<Project, typeof projectQualityIssueSettingsFields[number]>;

const projectSBOMPolicySettingsFields = ['sbomPolicyId', 'sbomAnalysisEnabled'] as const;
export type ProjectSBOMPolicySettings = Pick<Project, typeof projectSBOMPolicySettingsFields[number]>;

export type ProjectIssueFilters = { filters: Partial<Record<Category, number>> };
export type ProjectIssueSettings =
  & ProjectLicensingIssueSettings
  & ProjectSecurityIssueSettings
  & ProjectQualityIssueSettings
  & ProjectSBOMPolicySettings
  & ProjectIssueFilters;

export const pickIssueSettingsFromProject = (project: Project): ProjectIssueSettings =>
  _.pick(project, [
    ...projectLicensingIssueSettingsFields,
    ...projectSecurityIssueSettingsFields,
    ...projectQualityIssueSettingsFields,
    ...projectSBOMPolicySettingsFields,
    //  We also want to include the filter IDs for each category.
    'filters',
  ]);

export type GenericIssueSettingsProps = {
  isScanningEnabled: boolean;
  onToggleIsScanningEnabled: (isChecked: boolean) => void;
  policyOptions: Array<SelectOption<number | null>>;
  selectedPolicyOption: SelectOption<number | null>;
  onSelectedPolicyChange: (policyId: number | null) => void;
  isCICheckEnabled: boolean;
  onToggleIsCICheckEnabled: (isChecked: boolean) => void;
  filterOptions: Array<SelectOption<number | null>>;
  selectedFilterOption: SelectOption<number | null>;
  onSelectedFilterChange: (policyId: number | null) => void;
  canEditPolicy: boolean;
  canEditFilters: boolean;
};
